/**
 * 集計ページ共通の期間ツールバー: 日次／週次／月次の切替と前後移動(⑥指示)。
 */
import DateField from '@core/components/DateField';
import { IconChevronLeft, IconChevronRight } from '@core/components/icons';
import { PERIOD_LABELS, shiftAnchor, type PeriodData } from './usePeriod';

const inputStyle = { height: 30, padding: '0 8px', border: '1px solid var(--line)', borderRadius: 6, fontFamily: 'inherit', fontSize: 12.5 } as const;

export default function PeriodToolbar({ period, right, showModes = true }: { period: PeriodData; right?: React.ReactNode; showModes?: boolean }) {
  const { mode, setMode, anchor, setAnchor, range, latest } = period;
  return (
    <div className="toolbar" style={{ marginBottom: 14 }}>
      <div className="tool-filter" style={{ width: '100%' }}>
        {showModes && (
          <div className="chips" style={{ marginBottom: 0 }}>
            {(Object.keys(PERIOD_LABELS) as (keyof typeof PERIOD_LABELS)[]).map((m) => (
              <button key={m} className={`chip${mode === m ? ' on' : ''}`} onClick={() => setMode(m)}>
                {PERIOD_LABELS[m]}
              </button>
            ))}
          </div>
        )}
        <button className="chip" onClick={() => setAnchor(shiftAnchor(mode, anchor, -1))} aria-label="前へ">
          <IconChevronLeft size={13} />
        </button>
        {mode === 'year' ? (
          <input type="number" min={2020} max={2100} value={Number(anchor.slice(0, 4))} onChange={(e) => e.target.value && setAnchor(`${e.target.value}-01-01`)} style={{ ...inputStyle, width: 90 }} />
        ) : mode === 'month' ? (
          <input type="month" value={anchor.slice(0, 7)} onChange={(e) => e.target.value && setAnchor(`${e.target.value}-01`)} style={inputStyle} />
        ) : (
          <DateField value={anchor} onChange={setAnchor} />
        )}
        <button className="chip" onClick={() => setAnchor(shiftAnchor(mode, anchor, 1))} aria-label="次へ">
          <IconChevronRight size={13} />
        </button>
        <b style={{ fontSize: 14 }}>{range.label}</b>
        {latest && (
          <span className="hint">
            集計データの最新日: {latest.replaceAll('-', '/')}
            {latest !== anchor && mode === 'day' && (
              <button className="txn-link" onClick={() => setAnchor(latest)}>
                最新日へ
              </button>
            )}
          </span>
        )}
        {right && <span style={{ marginLeft: 'auto' }}>{right}</span>}
      </div>
    </div>
  );
}
